import styled from "@emotion/styled";
import Colors from "styles/colors";
export const StyledPositionsCareersComponent = styled.div`
  max-width: 894px;
  padding: 0 32px;
  margin: auto;

  .overview {
    font-size: 0.875rem;
    padding: 16px 12px;

    .number {
      font-weight: 700;
    }
  }

  .positions-container {
    .position-container {
      .divider {
        width: 100%;
        border: 0.5px solid ${Colors["border-gray"]};
      }
    }
  }
  
  .pagination-container {
    margin-top: 44px;
  }
`;
